import React, { Component } from 'react'

class Sidebar extends Component {
        constructor () {
                super();
                this.state = {
                        mymenu: []
                };
        }
        
        
        componentDidMount () {
                axios.get('/api/mymenu').then(response => {
                        this.setState({
                              mymenu: response.data
                        });
                });
        }
        
        render() {
                return (
                        <React.Fragment>
                    <button type="button" id="sidebarCollapse" className="btn btn-link text-white btn-icon">
                        <span>
                                <i className="material-icons md-18">menu</i><i className="material-icons md-18">arrow_back</i>
                        </span>
                        <h6 className="navbar-brand mb-0">シェアジョブ</h6>
                    </button>
                    <div id="dismiss">
                        <span></span>
                    </div>
                    <nav id="sidebar">
                        <div className="sidebar-header">
                        </div>

                        <ul className="list-unstyled components">
                                <li className="active">
                                        <a href="/home"><i className="material-icons">dashboard</i> ダッシュボード</a>
                                </li>
                                
                                {this.state.mymenu.map((item, v) => {
                                    if (item.children.length){
                                            return(
                                            <li key={v} className="sub-menu">
                                    <a href={"#sub-menu-"+v} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"><i className="material-icons" >{item.icon}</i> {item.title}</a>
                                                    <ul className="collapse list-unstyled" id={"sub-menu-"+v}>
                                                            {item.children.map((k, v) =>
                                                                    <li key={v}><a href={k.uri}> {k.title}</a></li>
                                                            )}
                                                    </ul>
                                            </li>
                                            );
                                    } else {
                                            return(
                                            <li key={v}>
                                                    <a href={item.uri}><i className="material-icons" >{item.icon}</i> {item.title}</a>
                                            </li>
                                            );
                                    }

                                })}
                        </ul>
                    </nav>
                </React.Fragment>
                );
        }
}

export default Sidebar
